import { Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements AfterViewInit {
  title = 'app';


  loading;
  constructor(
    private readonly router: Router
  ) {
    this.loading = true;
  }

  ngAfterViewInit() {
    this.router.events
      .subscribe((event) => {


        if (event instanceof NavigationStart) {
          // Show loading indicator
          this.loading = true;
        }

        if (event instanceof NavigationEnd) {
          // Hide loading indicator
          this.loading = false;
        }

        if (event instanceof NavigationError) {
          // Hide loading indicator
          // Present error to user
          this.loading = false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts